import { Link } from "react-router-dom";
import { SVGS } from ".";
const InviteNotFound = ({ active = false }) => {
  return (
    <div className="max-w-full sm:max-w-xl md:max-w-2xl lg:max-w-6xl xl:max-w-[85rem] mx-auto">
      <div className="flex flex-col justify-center gap-x-5 lg:gap-x-8 xl:gap-x-12 items-center">
        <div className="mt-4 lg:mt-0 overflow-hidden opacity-25">
          <SVGS.NotFoundSVG />
        </div>
        <div className="col-span-1 lg:col-span-4">
          <h1 className="text-lg font-bold text-gray-300 md:text-md lg:text-xl  ">
            Trenutno nemate {active ? "aktivnih" : "neaktivnih"} pozivnica
          </h1>
          <div className="mt-1 flex justify-center">
            <Link to="/nova-pozivnica">
              <button
                type="button"
                className="py-3 px-4 inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-teal-500 text-teal-500 hover:border-teal-400 hover:text-teal-400 disabled:opacity-50 disabled:pointer-events-none"
              >
                Kreiraj pozivnicu
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InviteNotFound;
